// extracted by mini-css-extract-plugin
module.exports = {"rich__text":"rich-text_rich__text__I_hrQ"};